import { useState } from 'react';

export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
    }`}>
      <div className="max-w-[1400px] mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <a href="/" className="flex items-center cursor-pointer">
            <img 
              src="https://static.readdy.ai/image/903de4eb32376445f3b73b45fb097895/9dff9b4a21cd3814528c6957a2a2f2ab.png" 
              alt="LineFlow Underground & Civil" 
              className="h-20 w-auto"
            />
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            <a 
              href="/" 
              className={`font-semibold transition-colors cursor-pointer ${
                isScrolled 
                  ? 'text-gray-700 hover:text-[#FF6B35]' 
                  : 'text-white/90 hover:text-white'
              }`}
            >
              Home
            </a>
            <a 
              href="/#services" 
              className={`font-semibold transition-colors cursor-pointer ${
                isScrolled 
                  ? 'text-gray-700 hover:text-[#FF6B35]' 
                  : 'text-white/90 hover:text-white'
              }`}
            >
              Services
            </a>
            <a 
              href="/projects" 
              className={`font-semibold transition-colors cursor-pointer ${
                isScrolled 
                  ? 'text-[#FF6B35]' 
                  : 'text-white font-bold'
              }`}
            >
              Projects
            </a>
            <a 
              href="/#contact" 
              className="px-6 py-3 bg-gradient-to-r from-[#FF6B35] to-[#FF8C42] text-white font-bold rounded-lg hover:shadow-lg hover:scale-105 transition-all whitespace-nowrap cursor-pointer"
            >
              Contact Us
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors cursor-pointer ${
              isScrolled ? 'bg-gray-100 text-[#0F4C81]' : 'bg-white/20 text-white'
            }`}
          >
            <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden mt-4 py-4 bg-white rounded-xl shadow-lg">
            <a href="/" className="block px-6 py-3 text-gray-700 hover:bg-[#FF6B35]/10 hover:text-[#FF6B35] transition-colors cursor-pointer">
              Home
            </a>
            <a href="/#services" className="block px-6 py-3 text-gray-700 hover:bg-[#FF6B35]/10 hover:text-[#FF6B35] transition-colors cursor-pointer">
              Services
            </a>
            <a href="/projects" className="block px-6 py-3 text-[#FF6B35] font-bold bg-[#FF6B35]/10 cursor-pointer">
              Projects
            </a>
            <a href="/#contact" className="block px-6 py-3 text-gray-700 hover:bg-[#FF6B35]/10 hover:text-[#FF6B35] transition-colors cursor-pointer">
              Contact
            </a>
          </div>
        )}
      </div>
    </nav>
  );
}
